export default {
  fieldIsRequired: {
    en: "Field is required",
    ja: "フィールドは必須項目です"
  }
}
